import React from "react";
import "./LegalPages.css";

export default function ContactPage({onBack}) {
    return (
        <div className="legal-page">
            <div className="legal-wrapper">
                {onBack && (
                    <button className="legal-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                <h1 className="legal-title">Nous contacter</h1>

                <p className="legal-paragraph">
                    Vous pouvez écrire au SAPPM à l'adresse <strong>sappm@pm.gouv.fr</strong>, ou par courrier au 20 avenue de Ségur, 75007 Paris.
                </p>
                <p className="legal-paragraph">
                    Si vous êtes déjà inscrit·e sur Paroles d'Agents, le bouton "🛟 J'ai besoin d'aide" présent dans l'application vous permet également d'écrire au SAPPM de façon anonyme, sous votre pseudonyme.
                </p>
            </div>
        </div>
    );
}
